import { render } from "./CampaignForm.vue?vue&type=template&id=24f40f44"
import script from "./CampaignForm.vue?vue&type=script&lang=js"
export * from "./CampaignForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__